/* assets/go-crm-samples-logic.js — pure helpers for the free-samples page (sections/go-crm-samples.liquid).
   Browser: window.GoCrmSamples. Node (tests/): module.exports. No DOM here. */
(function (root) {
  var MAX = 4;
  function clean(v, max) { return String(v == null ? '' : v).replace(/\s+/g, ' ').trim().slice(0, max); }
  function readParams(search) {
    var q = new URLSearchParams(search || '');
    var beers = clean(q.get('beers'), 400).split(',').map(function (b) { return clean(b, 60); }).filter(Boolean).slice(0, 5);
    var t = clean(q.get('t'), 64);
    var premise = clean(q.get('premise'), 8).toLowerCase();
    var next = clean(q.get('next'), 20).toLowerCase();
    var utm = {};
    q.forEach(function (v, k) { if (/^utm_[a-z]{1,20}$/.test(k) && clean(v, 200)) utm[k] = clean(v, 200); });
    return {venue: clean(q.get('venue'), 120), distributor: clean(q.get('distributor'), 120), beers: beers,
      t: /^[a-f0-9]{32}$/.test(t) ? t : '', premise: premise === 'on' || premise === 'off' ? premise : '', next: next === 'wholesale' ? 'wholesale' : '', utm: utm};
  }
  function addCan(tray, key) { return tray.length >= MAX ? tray : tray.concat([key]); }
  function removeCan(tray, key) {
    var i = tray.lastIndexOf(key);
    if (i < 0) return tray;
    return tray.slice(0, i).concat(tray.slice(i + 1));
  }
  function countOf(tray, key) { return tray.filter(function (k) { return k === key; }).length; }
  function slots(tray) { var out = []; for (var i = 0; i < MAX; i++) out.push(tray[i] || null); return out; }
  // Counter used in the selector header and the sticky tray.
  function trayMessage(n) { n = Math.max(0, Math.min(MAX, n | 0)); return n + ' of 4 selected'; }
  // Helper under the next-step CTA: why it's disabled, or what's left. The existing rule allows 1–4 cans.
  function ctaHelp(n) {
    if (n <= 0) return 'Pick at least 1 can (up to 4) to continue.';
    if (n >= MAX) return 'Your 4 are set.';
    return 'You can pick up to 4 — or continue now.';
  }
  // Hero greeting. The name is rendered as text (textContent) and uppercased by CSS. Names with no letter or
  // digit, or longer than 60 characters after trimming, fall back to the generic line.
  var HAS_WORD = (function () { try { return new RegExp('[\\p{L}\\p{N}]', 'u'); } catch (e) { return /[A-Za-z0-9\u00C0-\uFFFF]/; } })();
  function greetingLine(name) {
    var n = clean(name, 1000);
    if (!n || n.length > 60 || !HAS_WORD.test(n)) return "This round's on us.";
    return n + ", this round's on us.";
  }
  // Hero eyebrow: just the venue's name (uppercased by CSS), with the same validity rules as greetingLine;
  // otherwise the generic audience line.
  function heroEyebrow(name) {
    var n = clean(name, 1000);
    return !n || n.length > 60 || !HAS_WORD.test(n) ? 'For bars & restaurants' : n;
  }
  // "Lakeshore Beverage" → "Lakeshore": the first word when the name has 2+ words and that word has 4+ letters.
  function distShort(name) {
    var n = clean(name, 120); var w = n.split(' ');
    return w.length >= 2 && w[0].replace(/[^A-Za-z\u00C0-\uFFFF]/g, '').length >= 4 ? w[0] : n;
  }
  // Beer style from the Shopify title's subtitle ("Sunbeam Pils – Non-Alcoholic Pilsner" → "Pilsner").
  // Only the part before the first comma; never anything carrying banned copy.
  var BANNED = /zero alcohol|0\.0|alcohol-free|naperville/i;
  function styleOf(title) {
    var parts = String(title == null ? '' : title).split(/\s[–—-]\s/);
    if (parts.length < 2) return '';
    var st = parts.slice(1).join(' - ').replace(/^\s*gluten[- ]free\s*,\s*/i, '').split(',')[0];
    st = clean(st, 60).replace(/^non-alcoholic\s+/i, '');
    if (!st || BANNED.test(st) || /^non-alcoholic$/i.test(st) || /^gluten[- ]free$/i.test(st)) return '';
    return st;
  }
  // Hero proof, second line: the brewery's town only for Illinois venues (the venue API's state). This is the ONE
  // sanctioned use of the town name on the page (see copyOk); it never appears in static markup.
  var IL_PROOF = 'Brewed and canned in-house at our brewery in Naperville, Illinois.';
  var DEFAULT_PROOF = 'Brewed and canned in-house. Dedicated to non-alcoholic beer.';
  function proofLine(v) {
    var st = clean(v && v.venue && v.venue.address && v.venue.address.state, 30).toLowerCase();
    return st === 'il' || st === 'illinois' ? IL_PROOF : DEFAULT_PROOF;
  }
  // Copy check: banned phrases anywhere, except the one sanctioned Illinois proof line.
  function copyOk(text) { return !BANNED.test(String(text == null ? '' : text).split(IL_PROOF).join('')); }
  // Card titles: the STYLE leads (the beer name may mean nothing to a new buyer), the name sits under it.
  // No style known → the name is the primary line and there is no second line.
  function cardTitles(name, style) {
    var n = displayName(name), st = clean(style, 60);
    var same = function (a, b) { return clean(a, 200).toLowerCase() === clean(b, 200).toLowerCase(); };
    if (!st || same(st, n)) return {primary: st || n, secondary: ''};   // never the same words twice
    return {primary: st, secondary: n};
  }
  // Up to `max` real reviews for the page, from the cached Judge.me rows ({r, t, b, n, d, p, h, v}, newest first):
  // 5 stars only, body 40–280 characters, beers on this page only (by product handle — no merch, shipping protection
  // or shop reviews), nothing with banned copy, and nothing about shipping/service (those are about the box, not the
  // beer). Reviews that talk about taste go first; newest-first within each group. One review per beer first
  // (variety), then fill.
  // Prefix forms on purpose (ship…, deliver…, damage…, arriv…, explod…); whole words where a prefix would catch
  // unrelated words ("boxing", "credits"…). "in order to" is plain English, not an order — removed before the test.
  var OFF_TOPIC = /\b(ship|shipp|shipping|shipped|shipper|deliver|delivery|delivered|package|packaging|arriv|damage|damaged|explod|refund|customer service|fedex|ups|usps)|\b(order|ordered|box|credit|replace|broke|broken|dent|leak)\b/i;
  // Reviews that undercut "built like a beer" (e.g. "not reminiscent of beer… wish it was a cider") never make the page.
  var LUKEWARM = /\b(not reminiscent (of )?(a )?beer|doesn'?t taste like (a )?beer|not (like )?(a )?real beer|cider|seltzer)\b/i;
  function offTopic(text) { return OFF_TOPIC.test(String(text || '').replace(/\bin order to\b/gi, ' ')); }
  var TASTE = /\b(taste|tastes|flavor|flavour|hop|hoppy|crisp|refresh|smooth|delicious|best|like a real|real beer|full[- ]bodied|citrus|malt|sour|tart|pils|ipa|lager|stout)/i;
  function pickReviews(rows, beerHandles, max) {
    max = max || 6;
    var set = new Set((beerHandles || []).filter(Boolean));
    var ok = (Array.isArray(rows) ? rows : []).filter(function (x) {
      if (!x || x.r !== 5 || typeof x.h !== 'string' || !set.has(x.h)) return false;
      var body = clean(x.b, 2000);
      if (body.length < 40 || body.length > 280) return false;
      var text = [x.t, x.b].join(' ');
      if (offTopic(text)) return false;
      if (LUKEWARM.test(text)) return false;
      return copyOk([x.t, x.b, x.p].join(' '));
    });
    // taste first, keeping newest-first order inside each group
    var ranked = ok.filter(function (x) { return TASTE.test([x.t, x.b].join(' ')); })
      .concat(ok.filter(function (x) { return !TASTE.test([x.t, x.b].join(' ')); }));
    var out = [], used = new Set(), taken = new Set();
    ranked.forEach(function (x) { if (out.length < max && !used.has(x.h)) { used.add(x.h); out.push(x); taken.add(x); } });
    ranked.forEach(function (x) { if (out.length < max && !taken.has(x)) { out.push(x); taken.add(x); } });
    return ranked.filter(function (x) { return taken.has(x); });
  }
  // A review title worth showing: not when it only repeats the product name (case/space-insensitive, or contained in it).
  function reviewTitle(x) {
    var t = clean(x && x.t, 200), p = clean(x && x.p, 200).toLowerCase();
    if (!t) return '';
    var tl = t.toLowerCase();
    if (p && (tl === p || p.indexOf(tl) >= 0 || tl === displayName(p).toLowerCase())) return '';
    return t;
  }
  // Lucide icon geometry (lucide.dev, ISC) for the page's four UI affordances — drawn as inline SVG by the page JS
  // (stroke 2, currentColor, aria-hidden). Stars stay text: they are rating data, not icons.
  var ICONS = {
    info: [['circle', {cx: 12, cy: 12, r: 10}], ['path', {d: 'M12 16v-4'}], ['path', {d: 'M12 8h.01'}]],
    check: [['path', {d: 'M20 6 9 17l-5-5'}]],
    plus: [['path', {d: 'M5 12h14'}], ['path', {d: 'M12 5v14'}]],
    minus: [['path', {d: 'M5 12h14'}]]
  };
  // Where a venue can buy a beer: "Available via {short} or online" | "Available via {short}" | "Online only" | "Available online".
  // "Online only" is only true RELATIVE TO A KNOWN distributor (their rep doesn't carry it). With no distributor
  // on the link we don't know what their rep carries, so never claim "only" (Disarm is distributed widely).
  function availabilityLabel(isDist, isOnline, short) {
    if (isDist && short) return isOnline ? 'Available via ' + short + ' or online' : 'Available via ' + short;
    return short ? 'Online only' : 'Available online';
  }
  // Shopify handle for each sample key, from the Shopify-sourced lists (This month, beers, prospect). Distributor
  // tiles come from the venue API without a handle; this lets them match the sales-sheet feed by handle.
  function handlesByKey(items, keyOf) {
    var out = {};
    (items || []).forEach(function (p) {
      var k = p && keyOf(p);
      if (k && typeof p.handle === 'string' && p.handle && !Object.prototype.hasOwnProperty.call(out, k)) out[k] = p.handle;
    });
    return out;
  }
  // One-click wholesale after a confirmed claim: prefill {t-less} signup fields from the claim they just sent.
  // claim = {mode, full_name, phone, ship: {address1, city, province, zip}}; venue = venue API answer (address).
  // Address comes from the FedEx ship-to when they chose FedEx, else the venue's address on file. Only the fields
  // in `needs` go in the body (the server reads only those); `missing` lists needed fields still empty or malformed.
  var WS_FIELDS = ['contact_name', 'street', 'city', 'state', 'zip', 'phone'];
  function wholesalePrefill(claim, venue, needs) {
    claim = claim || {};
    var ship = claim.mode === 'fedex' && claim.ship ? claim.ship : null;
    var va = (venue && venue.venue && venue.venue.address) || {};
    var zip = clean(ship ? ship.zip : va.zip, 10); var z5 = /^(\d{5})(-\d{4})?$/.exec(zip);
    var v = {
      contact_name: clean(claim.full_name, 80),
      phone: clean(claim.phone, 30),
      street: clean(ship ? ship.address1 : va.street, 120),
      city: clean(ship ? ship.city : va.city, 60),
      state: clean(ship ? ship.province : va.state, 20).toUpperCase(),
      zip: z5 ? z5[1] : zip
    };
    var need = (Array.isArray(needs) ? needs : []).filter(function (k) { return WS_FIELDS.indexOf(k) >= 0; });
    if (need.indexOf('contact_name') < 0) need.unshift('contact_name');   // a name is always needed
    var body = {}, missing = [];
    need.forEach(function (k) {
      body[k] = v[k];
      var bad = !v[k] || (k === 'state' && !/^[A-Z]{2}$/.test(v[k])) || (k === 'zip' && !/^\d{5}$/.test(v[k])) ||
        (k === 'phone' && v[k].replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '').length !== 10);
      if (bad) missing.push(k);
    });
    return {body: body, missing: missing, values: v};
  }

  // ---- online wholesale straight from the claim (no second form) ----
  // The claim answer carries {claim_id, ws_key}: a one-time key the page keeps IN MEMORY only (never the URL or storage).
  function claimKeyOf(resp) {
    var id = resp && resp.claim_id, key = resp && resp.ws_key;
    if (typeof id !== 'string' || !/^(v_[A-Za-z0-9_-]{1,160}|e_[a-f0-9]{24})$/.test(id)) return null;
    if (typeof key !== 'string' || !/^[a-f0-9]{32}$/.test(key)) return null;
    return {claim_id: id, ws_key: key};
  }
  function httpsUrl(u) { return typeof u === 'string' && /^https:\/\/[^\s"'<>]+$/.test(u) ? u : null; }
  // POST /api/crm/wholesale-signup {claim_id, ws_key} → what the page shows next.
  //   approved | already (+ a sign-in link) → 'approved'; pending_review (or an already-received application) → 'submitted';
  //   anything else (bad/expired key, refused, server error) → 'fallback' = the plain application link.
  function claimWsOutcome(httpOk, json) {
    var j = json && typeof json === 'object' ? json : {};
    var login = httpsUrl(j.login_url);
    var email = typeof j.email === 'string' ? j.email : '';
    if (httpOk && j.status === 'approved') return {result: login ? 'approved' : 'submitted', login: login, email: email};
    if (httpOk && j.status === 'pending_review') return {result: 'submitted', login: null, email: ''};
    if (httpOk && j.status === 'already') {
      if (j.was === 'pending_review') return {result: 'submitted', login: null, email: ''};
      return login ? {result: 'approved', login: login, email: email} : {result: 'submitted', login: null, email: ''};
    }
    return {result: 'fallback', login: null, email: ''};
  }
  // Which step-2 action to show. s = {w: venue API `wholesale` block | null, hasToken, claimStatus, claimKey: bool,
  // claimWs: {result, login} | null}. The external application link is the LAST resort: no token and no claim key.
  function wholesaleMode(s) {
    s = s || {};
    var w = s.w && typeof s.w === 'object' ? s.w : null;
    var cw = s.claimWs || {};
    if (w && w.approved === true) return httpsUrl(w.login_url) ? 'approved' : 'link';
    if (cw.result === 'approved' && httpsUrl(cw.login)) return 'approved';
    if (cw.result === 'submitted' || cw.result === 'approved') return 'submitted';
    if (s.hasToken && w && s.claimStatus !== 'pending_approval') return 'oneclick';
    if (s.claimKey && cw.result !== 'fallback') return 'claim';
    return 'link';
  }

  // ---- tasting notes + sales sheet (the public sales-sheet feed) ----
  // Only beer-like entries count: ones with facts or a marketing_short (merch and gift cards have neither).
  function notesIndex(feed) {
    var idx = {byHandle: {}, byName: {}};
    ((feed && feed.beers) || []).forEach(function (b) {
      if (!b || typeof b !== 'object' || !(b.facts || b.marketing_short)) return;
      if (typeof b.handle === 'string' && b.handle && !idx.byHandle[b.handle]) idx.byHandle[b.handle] = b;
      var nk = nameKey(b.title);
      if (nk && !idx.byName[nk]) idx.byName[nk] = b;
    });
    return idx;
  }
  // Shopify handle first; a card without a handle (distributor-only) matches by its shown name.
  function notesFor(tile, idx) {
    if (!idx || !tile) return null;
    if (tile.handle && idx.byHandle[tile.handle]) return idx.byHandle[tile.handle];
    var nk = nameKey(tile.name);
    return (nk && idx.byName[nk]) || null;
  }
  // Sentence split without look-behind (older Safari can't parse it): a sentence ends at . ! ? followed by a space.
  function sentences(t) {
    var s = String(t || '').replace(/\s+/g, ' ').trim(), out = [], start = 0;
    for (var i = 0; i < s.length; i++) {
      if ('.!?'.indexOf(s.charAt(i)) >= 0 && (i === s.length - 1 || s.charAt(i + 1) === ' ')) { out.push(s.slice(start, i + 1).trim()); start = i + 1; }
    }
    if (start < s.length && s.slice(start).trim()) out.push(s.slice(start).trim());
    return out;
  }
  function cut(t, max) {
    if (t.length <= max) return t;
    var c = t.slice(0, max); var sp = c.lastIndexOf(' ');
    return (sp > max * 0.6 ? c.slice(0, sp) : c).replace(/[\s,;:—–-]+$/, '') + '…';
  }
  // The blurb: marketing_short, else the first sentence of the description. Any sentence carrying banned copy is
  // dropped (never shown); never longer than ~200 characters.
  function blurbOf(b) {
    if (!b) return '';
    var src = b.marketing_short ? sentences(b.marketing_short) : sentences(b.description).slice(0, 1);
    var ok = src.filter(function (x) { return !BANNED.test(x); }).join(' ');
    return ok ? cut(ok, 200) : '';
  }
  // "ABV 0.4% · 66 cal · Hops: Citra" — only the parts that exist. An ABV that rounds to zero at one decimal is
  // left out (it would print as a zero-point-zero percentage, which the copy rules forbid).
  function factsLine(f) {
    if (!f || typeof f !== 'object') return '';
    var parts = [];
    var abv = Number(f.abv);
    if (f.abv != null && isFinite(abv) && Math.round(abv * 10) > 0) parts.push('ABV ' + (Math.round(abv * 10) / 10).toFixed(1) + '%');
    var cal = Number(f.calories);
    if (f.calories != null && f.calories !== '' && isFinite(cal)) parts.push(Math.round(cal) + ' cal');
    var hops = clean(f.hops, 80);
    if (hops) parts.push('Hops: ' + hops);
    return parts.filter(function (p) { return !BANNED.test(p); }).join(' · ');
  }
  // Everything the ⓘ panel shows, or null when there is nothing (then no ⓘ at all).
  function notesContent(b) {
    if (!b) return null;
    var sheet = typeof b.sales_sheet_url === 'string' && /^https:\/\/[^\s"'<>]+$/.test(b.sales_sheet_url) ? b.sales_sheet_url : '';
    var c = {blurb: blurbOf(b), facts: factsLine(b.facts), sheet: sheet};
    return c.blurb || c.facts || c.sheet ? c : null;
  }

  // Client-side check mirroring Brewery OS validateClaim, so errors show next to the field before a round trip.
  // hasToken: an emailed link already knows the venue, so the server fills a blank business name from it.
  function validateClaim(f, mode, hasToken) {
    var e = {}, v = function (k) { return clean(f && f[k], 200); };
    if (!v('full_name')) e.full_name = 'Add your name.';
    if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(v('email'))) e.email = 'Check your email address.';   // same regex as the server
    var ph = v('phone').replace(/\D/g, ''); if (ph.length === 11 && ph.charAt(0) === '1') ph = ph.slice(1);
    if (ph.length !== 10) e.phone = 'Check your phone number.';
    if (mode !== 'rep') {
      if (!hasToken && !v('company')) e.company = 'Add your business name.';
      if (!v('address1')) e.address1 = 'Add a street address.';
      if (!v('city')) e.city = 'Add a city.';
      if (!/^[A-Za-z]{2}$/.test(v('province'))) e.province = 'Use the 2-letter state (e.g. IL).';
      if (!/^\d{5}(-\d{4})?$/.test(v('zip'))) e.zip = 'Add a 5-digit ZIP code.';
    }
    return e;
  }
  // Which field a server claim error is about (its messages are fixed strings), or null.
  function fieldForServerError(msg) {
    var m = String(msg || '');
    var map = [[/your name/i, 'full_name'], [/email/i, 'email'], [/phone/i, 'phone'], [/business name/i, 'company'], [/street address/i, 'address1'], [/a city/i, 'city'], [/2-letter state/i, 'province'], [/zip/i, 'zip']];
    for (var i = 0; i < map.length; i++) if (map[i][0].test(m)) return map[i][1];
    return null;
  }
  // Shopify titles carry a subtitle after an en/em dash or hyphen ("Sunbeam – Non-Alcoholic Wheat Ale").
  // DISPLAY ONLY — the part before the dash. The full title is still what goes to the samples lookup.
  function displayName(name) { return String(name == null ? '' : name).split(/\s[–—-]\s/)[0]; }
  // Same beer = same name as shown (so "F*kn Pumpkin – Spiced" and "F*kn Pumpkin" are one card).
  function nameKey(name) { return clean(displayName(name), 200).toLowerCase(); }
  function dedupeCards(cards) {
    var seen = {};
    return cards.filter(function (c) { var k = nameKey(c.name); if (!k || seen[k]) return false; seen[k] = 1; return true; });
  }

  // "Try something new" after the samples lookup: one card per sample KEY; items without a key fall back to
  // their shown name. A later duplicate's note (e.g. the venue API's seasonal note) is kept only when it is the
  // same beer by that identity — never moved onto a different key. Returns new objects; inputs untouched.
  function dedupeByKey(items, keyOf) {
    var seen = {}, out = [];
    (items || []).forEach(function (it) {
      var k = keyOf(it), id = k ? 'k:' + k : 'n:' + nameKey(it.name);
      if (id === 'n:') return;
      if (seen[id]) { if (it.note && !seen[id].note) seen[id].note = it.note; return; }
      var copy = {}; Object.keys(it).forEach(function (f) { copy[f] = it[f]; });
      seen[id] = copy; out.push(copy);
    });
    return out;
  }
  // The tray saved in sessionStorage, kept only for cans that exist on this page now (in-stock sample keys).
  function restoreTray(saved, validKeys) {
    var ok = {}; (validKeys || []).forEach(function (k) { if (k) ok[k] = 1; });
    return (Array.isArray(saved) ? saved : []).filter(function (k) { return typeof k === 'string' && ok[k]; }).slice(0, MAX);
  }

  var FRESH_TAGS = ['seasonal', 'limited', 'botm', 'beer of month'];
  function isFresh(p) { return (p.tags || []).some(function (t) { return FRESH_TAGS.indexOf(String(t).toLowerCase()) >= 0; }); }
  // Order-direct sort. Always returns a new array; ties keep the incoming (collection) order.
  //   popular — by index in popularRank (the best-selling smart collection's handles); unranked last, original order
  //   az      — by display name, case-insensitive
  //   new     — seasonal/limited/botm/beer-of-month tagged first, then newest published first
  function sortDirect(list, mode, popularRank) {
    var rank = {};
    (popularRank || []).forEach(function (h, i) { if (!(h in rank)) rank[h] = i; });
    var cmp;
    if (mode === 'az') {
      cmp = function (a, b) { var x = displayName(a.name).toLowerCase(), y = displayName(b.name).toLowerCase(); return x < y ? -1 : x > y ? 1 : 0; };
    } else if (mode === 'new') {
      cmp = function (a, b) { return (isFresh(b) ? 1 : 0) - (isFresh(a) ? 1 : 0) || (Number(b.published_at) || 0) - (Number(a.published_at) || 0); };
    } else {
      var r = function (p) { return p.handle in rank ? rank[p.handle] : Infinity; };
      cmp = function (a, b) { var x = r(a), y = r(b); return x === y ? 0 : x < y ? -1 : 1; };
    }
    return (list || []).map(function (p, i) { return {p: p, i: i}; })
      .sort(function (a, b) { return cmp(a.p, b.p) || a.i - b.i; })
      .map(function (w) { return w.p; });
  }
  // Products whose sample key is one the venue's distributor already carries go behind "Show more".
  // No key → can't prove it's carried → stays in main.
  function splitCarried(list, carriedKeys, keyOf) {
    var set = {};
    (carriedKeys || []).forEach(function (k) { if (k) set[k] = 1; });
    var out = {main: [], carried: []};
    (list || []).forEach(function (p) { var k = keyOf(p); (k && set[k] ? out.carried : out.main).push(p); });
    return out;
  }
  // ---- the one sample grid ("Choose 4 free samples") ----
  // A tile is 'dist' when its sample key is one of the distributor beers' keys, else 'online'.
  function labelFor(key, distKeys) { return key && (distKeys || []).indexOf(key) >= 0 ? 'dist' : 'online'; }
  // Where a tile comes from. distKeyIdx maps each distributor sample key → its position in the ORIGINAL
  // distributor list; distMark is the tile's own position in that list when it came from it (else null).
  // Keyed tiles are labelled by key; a keyless tile is the distributor's only if it IS one of their beers.
  function tileSource(key, distKeyIdx, distMark) {
    if (key) return distKeyIdx && Object.prototype.hasOwnProperty.call(distKeyIdx, key) ? {label: 'dist', distIdx: distKeyIdx[key]} : {label: 'online', distIdx: null};
    return distMark != null ? {label: 'dist', distIdx: distMark} : {label: 'online', distIdx: null};
  }
  // The sort only reorders non-distributor tiles — worth showing when at least 2 of them are in view.
  function sortUseful(list) { return (list || []).filter(function (t) { return t.label !== 'dist'; }).length >= 2; }
  // mode: 'all' | 'dist' | 'online'. Without a distributor there is only one way to carry Go, so every mode is 'all'.
  function filterTiles(tiles, mode, hasDist) {
    if (!hasDist || mode === 'all' || (mode !== 'dist' && mode !== 'online')) return (tiles || []).slice();
    return (tiles || []).filter(function (t) { return t.label === mode; });
  }
  // Order within the current filter (tiles: {label, botm, distIdx, name, handle, tags, published_at}):
  //   distributor tiles first, in the distributor's best-seller order (distIdx);
  //   then This month (botm); then the rest by the active sort (see sortDirect).
  // Under 'dist' that is just distributor order; under 'online' it is This month first, then the sort.
  function orderTiles(tiles, mode, sort, popularRank) {
    var list = filterTiles(tiles, mode, true);
    var dist = list.filter(function (t) { return t.label === 'dist'; })
      .map(function (t, i) { return {t: t, i: i}; })
      .sort(function (a, b) { var x = a.t.distIdx == null ? Infinity : a.t.distIdx, y = b.t.distIdx == null ? Infinity : b.t.distIdx; return (x === y ? 0 : x < y ? -1 : 1) || a.i - b.i; })
      .map(function (w) { return w.t; });
    var rest = list.filter(function (t) { return t.label !== 'dist'; });
    var botm = rest.filter(function (t) { return t.botm; });
    var others = sortDirect(rest.filter(function (t) { return !t.botm; }), sort, popularRank);
    return dist.concat(botm, others);
  }

  // Bars & restaurants offer: the venue API decides when it answered; otherwise the email link's premise=on.
  // Stars under each can: Judge.me rating ({r, max, n} from the page data) → "4.8 (212)" + a spoken label; null when
  // there is no usable rating (no count, bad numbers).
  function ratingLabel(rt) {
    if (!rt || typeof rt !== 'object') return null;
    var n = Math.floor(Number(rt.n)), r = parseFloat(rt.r), max = parseFloat(rt.max) || 5;
    if (!(n > 0) || !(r > 0) || !(max > 0)) return null;
    var five = Math.min(5, Math.round(r / max * 5 * 10) / 10);
    var num = five.toFixed(1), cnt = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return {text: num + ' (' + cnt + ')', aria: 'Rated ' + num + ' out of 5 from ' + cnt + (n === 1 ? ' review' : ' reviews')};
  }
  // Claim-sheet prefill from the venue API answer (/api/crm/venue: venue.name, venue.address, venue.phone, wholesale.email) and the
  // URL's venue name. Only fields we know; the page fills an input only while it is still empty.
  function claimPrefill(v, params) {
    var out = {};
    var ven = v && v.venue, a = ven && ven.address, w = v && v.wholesale;
    var put = function (k, val, max) { var c = clean(val, max); if (c) out[k] = c; };
    put('company', (ven && ven.name) || (params && params.venue), 120);
    if (a) { put('address1', a.street, 120); put('city', a.city, 80); put('province', String(a.state || '').length === 2 ? String(a.state).toUpperCase() : '', 2); put('zip', a.zip, 10); }
    if (ven && typeof ven.phone === 'string' && /\d{7,}/.test(ven.phone.replace(/\D/g, ''))) put('phone', ven.phone, 40);
    if (w && typeof w.email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(w.email.trim())) put('email', w.email, 120);
    return out;
  }
  function showBarsOffer(v, params) {
    if (v) return v.on_premise === true;
    return !!params && params.premise === 'on';
  }

  var api = {MAX: MAX, readParams: readParams, addCan: addCan, removeCan: removeCan, countOf: countOf, slots: slots, trayMessage: trayMessage, ctaHelp: ctaHelp, greetingLine: greetingLine, heroEyebrow: heroEyebrow, distShort: distShort, styleOf: styleOf,
    availabilityLabel: availabilityLabel, proofLine: proofLine, pickReviews: pickReviews, ICONS: ICONS, reviewTitle: reviewTitle, copyOk: copyOk, cardTitles: cardTitles, IL_PROOF: IL_PROOF, validateClaim: validateClaim, fieldForServerError: fieldForServerError,
    handlesByKey: handlesByKey, wholesalePrefill: wholesalePrefill, claimKeyOf: claimKeyOf, claimWsOutcome: claimWsOutcome, wholesaleMode: wholesaleMode,
    notesIndex: notesIndex, notesFor: notesFor, blurbOf: blurbOf, factsLine: factsLine, notesContent: notesContent,
    dedupeCards: dedupeCards, displayName: displayName, nameKey: nameKey, dedupeByKey: dedupeByKey, restoreTray: restoreTray, sortDirect: sortDirect, splitCarried: splitCarried, showBarsOffer: showBarsOffer, ratingLabel: ratingLabel, claimPrefill: claimPrefill,
    labelFor: labelFor, tileSource: tileSource, sortUseful: sortUseful, filterTiles: filterTiles, orderTiles: orderTiles};
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.GoCrmSamples = api;
})(typeof window !== 'undefined' ? window : this);
